import React from 'react'

/**
 * TODO: move to components without data
 */
const LoginLogo = () => (
  <div className="login-logo">
    <span className="login-logo__text">
      Pro<span className="login-logo__accent">Habits</span>
    </span>
  </div>
)

LoginLogo.displayName = 'LoginLogo'

export default LoginLogo
